import * as React from 'react';

var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgTransportDriven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "motorway-svg-stroke motorway-svg-fill",
    d: "M14.2 22.6h10.7v-2.1H14.2zm-6.6 0H11v-2.1H7.5zm20.2 0h3.8v-2.1h-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "motorway-svg-stroke motorway-svg-fill",
    d: "M32.4 13.8l1.6 3.1v11.8c0 .2-.2.4-.5.4h-3.3l-.9-2.3h-20L8.5 29l-.2.2H5.5a.3.3 0 01-.3-.3v-12l1.6-3a102.5 102.5 0 0025.6-.1zM16.2 9.3c1 0 1.8.7 2 1.7l.2 1.4H18l-1.7.3v-.3l-.2-1h-3.6l-.1.8-.1.6-2.2-.3.1-.5.1-1a2 2 0 012-1.7zM9.1 4.6c0-.4.3-.7.6-.7a36 36 0 0119.2 0c.3 0 .6.4.7.8l1.6 7c-4.4.5-8.8.8-13.2.7l-1.7.3v-.3l-4-.2v.6l-2.2-.3.1-.5c-1 0-1.9-.2-2.8-.3l1.7-7.1zM38.6 12V9.8h-4.3l-1 1.2-1.6-6.7a3.3 3.3 0 00-2.3-2.5 38.2 38.2 0 00-20.3 0A3 3 0 007 4l-1.6 6.8-1-1.1H.2V12h3.3l1.1 1.3-1.5 3.1V29c0 1.3 1 2.4 2.3 2.4h2.8c1 0 2-.6 2.3-1.5l.3-.8h17l.4 1c.3.8 1.1 1.4 2 1.4l3.4-.1c1.4 0 2.5-1.2 2.5-2.6V16.4L34.4 13l1-1h3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "motorway-svg-stroke motorway-svg-fill",
    d: "M14.3 8.4a2 2 0 100-4 2 2 0 000 4"
  }))));
}

export { SvgTransportDriven as S };
